import { render, staticRenderFns } from "./TransferProgress.vue?vue&type=template&id=7b9045f8"
import script from "./TransferProgress.vue?vue&type=script&lang=js"
export * from "./TransferProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports